import extendedFieldHooks from "ExtendedFields/selectorHooks";
import FnrTypography from "FnrTypography/FnrTypography";

import FnrCard from "UI/FnrCard/FnrCard";
import FnrCheckbox from "UI/FnrEnrichedCheckbox/FnrCheckbox";
import FnrIcon from "UI/FnrIcon/FnrIcon";

import extendedFieldInputContainers from "../containers";

const { HorizontalGap, VerticallyCentered, IconContainer } =
  extendedFieldInputContainers;

const ShowOnSignUp = () => {
  const [showOnSignup, setShowOnSignUp] = extendedFieldHooks.useShowOnSignUp();
  const [editPermission] = extendedFieldHooks.useEditPermissionId();

  const handleSetShowOnSignUp = () => {
    const newValue = showOnSignup === 1 ? 0 : 1;
    setShowOnSignUp(newValue);
  };

  return (
    <FnrCard data-cy="ExtendedFields_ShowOnSignUp">
      <HorizontalGap>
        <VerticallyCentered>
          <FnrCheckbox
            data-cy="ShowOnsignUp_Checkbox"
            on={showOnSignup === 1}
            toggleOn={handleSetShowOnSignUp}
            disabled={editPermission > 1}
          >
            <FnrTypography>
              Ask members for this information when they sign up for your group
              online or via text-to-join.
            </FnrTypography>
          </FnrCheckbox>
          <IconContainer>
            <FnrIcon icon="fa-browser far" />
          </IconContainer>
        </VerticallyCentered>
      </HorizontalGap>
    </FnrCard>
  );
};

export default ShowOnSignUp;
